<template>
    <div class="outcome">
        <QuestionnaireCard
            v-if="questionnaire"
            v-bind:questionnaire="questionnaire"
            :key="questionnaire">
        </QuestionnaireCard>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import QuestionnaireCard from './QuestionnaireCard'

import ProgressBar from '@/module/component/ProgressBar'
import QuestionnaireFilter from './QuestionnaireFilter'
import QuestionnaireStats from './QuestionnaireStatistics'
// import QuestionnaireGraph from './QuestionnaireGraph'
import PatientList from './PatientList'
import OutcomeMixin from './mixin'


export default {
    name: 'outcome',
    mixins: [ OutcomeMixin ],

    watch: {
        $route(to, from) {
            if (!to.query.hasOwnProperty('start') || !to.query.hasOwnProperty('end')) {
                this.dateTime = []
            }
        }
    },

    data() {
        return {
            dateTime: [],
            openDialog: false,
            patientListMessage: '',
            selectedGraphPatients: [],
            patientListColor: '#913b9c'
        }
    },

    created() {
        console.log('outcome')
		this.loadPatients()
        if (this.questionnaire)
            this.loadQuestionnaire(this.questionnaire)
    },

	watch: {
		$route() {
            if (this.questionnaire)
                this.loadQuestionnaire(this.questionnaire)
		}
	},

    mounted() {
        if(this.getProviderList.length > 0)
            this.setCurrentProvider(this.getProviderList[0].provider)
    },

    methods: {
        ...mapActions('provider', ['loadQuestionnaire', 'loadPatients', 'setCurrentProvider']),
        filterAnalysis(data) {
            if (data.hasOwnProperty('start') && data.hasOwnProperty('end')) {
                this.dateTime = [new Date(data.start).toDateString(), new Date(data.end).toDateString()]
                data.end += 86400000 // added another day to make end date inclusive
            }
            data.id = this.questionnaire
            // this.getQuestionnaireData(data)
        },
        emittedPatientList(data) {
            this.openDialog = true
            this.patientListColor = data.color
            this.selectedGraphPatients = data.patients
            this.patientListMessage = data.message
        }
    },

    computed: {
        ...mapGetters('provider', ['getProviderList']),
        ...mapState('outcome', {
            patientCount(state) {
                const questionnaireData = state.questionnaire[this.questionnaire]
                const questionList = questionnaireData ? questionnaireData.question : []
                const patientList = questionnaireData ? questionnaireData.patient : []
                const patientHash = patientList.reduce((acc, patient) => {
                    acc[patient.id] = {}
                    return acc
                }, {})
                let patientCount = {
                    total: patientList.map(patient => patient.id)
                }
                return patientCount
            },
            patientList(state) {
                return state.questionnaire[this.questionnaire] ? state.questionnaire[this.questionnaire].patient : []
            },
            isLoading(state) {
                return state.loading[this.questionnaire]
            }
        }),
        ...mapState('content', {
            /**
             * The current title of the questionnaire
             * @returns {String}
             */
            questionnaireTitle(state) {
                if(!state.data.questionnaire) return ''
                return state.data.questionnaire[this.questionnaire] ? state.data.questionnaire[this.questionnaire].title : ''
            }
        })
    },
    components: {
        ProgressBar,
        QuestionnaireCard,
        QuestionnaireFilter,
        QuestionnaireStats,
        PatientList
    }
}
</script>

<style lang="scss" scoped>
.outcome {
    background: #fafafa;
    padding: 20px;
}
</style>
